/**
 * One labelled figure on a phone venue card (BON-538).
 *
 * The label sits ABOVE the value, small and uppercase, because three of these
 * run across a 390px card and a label beside its value would wrap before the
 * third one fits.
 */
export interface VenueCardStatProps {
  label: string;
  value: number;
}

export function VenueCardStat({ label, value }: VenueCardStatProps) {
  return (
    <div>
      <div className="nb-eyebrow" style={{ fontSize: 9.5 }}>
        {label}
      </div>
      <div className="nb-tabular" style={{ fontSize: 17, fontWeight: 600, lineHeight: 1.2 }}>
        {value}
      </div>
    </div>
  );
}
